import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { FormEventService } from '@hub/services/form-event.service';

@Component({
  selector: 'reset-btn',
  templateUrl: 'reset-btn.component.html'
})
export class ResetBtnComponent implements OnInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    public formEventService: FormEventService
  ) {}

  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Input() value: any;
  @Input() isHover: boolean;

  isOn: boolean = false;
  private innerValue: any;

  ngOnInit() {
    if (!this.innerValue) {
      this.innerValue = this.value;
    }
    this.formEventService.getReset().subscribe(
      x => {
        if (x) {
          this.innerValue = this.value;
        }
      }
    );
  }

  refresh(): void {
    this.change.emit(this.innerValue);
  }
}
